import { render, staticRenderFns } from "./EdicaoDocumentosPenalidadeAtaListagem.vue?vue&type=template&id=a65a6214"
import script from "./EdicaoDocumentosPenalidadeAtaListagem.vue?vue&type=script&lang=js"
export * from "./EdicaoDocumentosPenalidadeAtaListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports